export default __webpack_public_path__ + "static/media/dermaheal5.3146e6c8.jpg";